export default __webpack_public_path__ + "static/media/Inter-LightItalic.b199a1a0.woff";